import { render, staticRenderFns } from "./LogoComponent.vue?vue&type=template&id=6c91ed23&scoped=true&"
import script from "./LogoComponent.vue?vue&type=script&lang=js&"
export * from "./LogoComponent.vue?vue&type=script&lang=js&"
import style0 from "./LogoComponent.vue?vue&type=style&index=0&id=6c91ed23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91ed23",
  null
  
)

export default component.exports